import React from "react"
import { Card, Icon } from "semantic-ui-react"
import ChangeUserLimitModal from "../../../Pages/MainPanel/MainPanelBody/Organizations_Activity/OrganizationsModal/ChangeUserLimitModal"
import Loader from "../Loader/Loader"

const BifrostOrgUserLimitComponent = ({ chosenOrg, refreshData, orgDetailsLoading }) => {
	return (
		<Card fluid style={{ height: "100%" }}>
			<Card.Content textAlign="center">
				<Card.Header>
					<Icon name="users" />
					User Limit
				</Card.Header>
				<Card.Description>{orgDetailsLoading ? <Loader backgroundColor="white" inverted height="1px" minHeight="55px" /> : <h3>{chosenOrg.user_limit}</h3>}</Card.Description>
			</Card.Content>
			<Card.Content extra textAlign="center">
				<ChangeUserLimitModal chosenOrg={chosenOrg} refreshOrgDetails={refreshData} orgDetailsLoading={orgDetailsLoading} />
			</Card.Content>
		</Card>
	)
}

export default BifrostOrgUserLimitComponent
